import { render, staticRenderFns } from "./AddonProductSkeleton.vue?vue&type=template&id=3cb8f553&scoped=true&"
var script = {}
import style0 from "./AddonProductSkeleton.vue?vue&type=style&index=0&id=3cb8f553&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb8f553",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Globaltask\\Documents\\Happybox Store\\Happybox Site\\corporate-builder\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cb8f553')) {
      api.createRecord('3cb8f553', component.options)
    } else {
      api.reload('3cb8f553', component.options)
    }
    module.hot.accept("./AddonProductSkeleton.vue?vue&type=template&id=3cb8f553&scoped=true&", function () {
      api.rerender('3cb8f553', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "CorporateBuilder/components/Skeletons/AddonProductSkeleton.vue"
export default component.exports